import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const messages = [{
  name: 'Mariana',
  city: 'Buenos Aires',
  action: 'acaba de comprar el Manual de Emergencias para Mascotas.'
}, {
  name: 'Carlos',
  city: 'Bogotá',
  action: 'acaba de obtener el pack completo.'
}, {
  name: 'Valentina',
  city: 'Lima',
  action: 'acaba de acceder al manual.'
}, {
  name: 'Andrés',
  city: 'Santiago',
  action: 'acaba de descargar el manual completo.'
}, {
  name: 'Lucía',
  city: 'Montevideo',
  action: 'acaba de comprar el pack con los 3 bonos.'
}, {
  name: 'Diego',
  city: 'Medellín',
  action: 'acaba de obtener el Manual de Emergencias.'
}, {
  name: 'Camila',
  city: 'Quito',
  action: 'acaba de acceder al pack completo.'
}, {
  name: 'Sebastián',
  city: 'Ciudad de México',
  action: 'acaba de comprar el manual.'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    // First appearance after 8 seconds
    const initialTimer = setTimeout(() => {
      setVisible(true);
      // Hide after 5 seconds
      setTimeout(() => setVisible(false), 5000);
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (dismissed) return;
    // Rotate every 30 seconds after initial show
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % messages.length);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    }, 30000);
    return () => clearInterval(interval);
  }, [dismissed]);
  if (dismissed) return null;
  const msg = messages[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-xs bg-white rounded-lg shadow-lg border border-gray-200 p-4 transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-150">
      <button onClick={() => setDismissed(true)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar" data-id="element-151">
        <XIcon className="w-3.5 h-3.5" data-id="element-152" />
      </button>
      <div className="flex items-start gap-3 pr-4" data-id="element-153">
        <div className="bg-[#FEF3C7] rounded-full p-2 flex-shrink-0 mt-0.5" data-id="element-154">
          <ShoppingBagIcon className="w-4 h-4 text-[#D97706]" data-id="element-155" />
        </div>
        <p className="text-[13px] text-[#374151] leading-snug" data-id="element-156">
          <span className="font-semibold" data-id="element-157">{msg.name}</span> de{' '}
          <span className="font-semibold" data-id="element-158">{msg.city}</span> {msg.action}
        </p>
      </div>
      <div className="mt-2 text-[11px] text-[#9CA3AF]" data-id="element-159">Hace unos momentos</div>
    </div>;
}